export const prepayment_user_auth = [
  "mleon@admediaryllc.com",
  "csrichards@admediaryllc.com",
  "awelch@admediaryllc.com",
  "jvillanueva@admediaryllc.com",
  "msunderlin@admediaryllc.com",
  "ckennedy@admediaryllc.com",
  "apalchak@admediaryllc.com",
];
